import { useTranslation } from 'react-i18next';
import Button from 'src/components/design-system/Button';
import ClearFilterButton from 'src/components/design-system/ClearFilterButton';
import PopUp from 'src/components/design-system/PopUp';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import { useContextSelector } from 'use-context-selector';
import { ShoppingCartContext } from './ShoppingCartContext';

const ShoppingCartToolbarActions = () => {
  const { t } = useTranslation();

  const clearFilters = useContextSelector(ShoppingCartContext, (context) => context.clearFilters);
  const hasActiveFilters = useContextSelector(
    ShoppingCartContext,
    (context) => context.hasActiveFilters
  );
  const hasSelectedItems = useContextSelector(
    ShoppingCartContext,
    (context) => context.hasSelectedItems
  );
  const handleDeleteSelected = useContextSelector(
    ShoppingCartContext,
    (context) => context.handleDeleteSelected
  );
  const isDeletingCartItems = useContextSelector(
    ShoppingCartContext,
    (context) => context.isDeletingCartItems
  );

  return (
    <div className="flex w-full flex-row flex-wrap items-center gap-x-2 gap-y-2">
      <div className="flex min-w-0 flex-row flex-wrap items-center gap-1">
        <ClearFilterButton onClick={clearFilters} disabled={!hasActiveFilters} />
        <PopUp
          popupAlign={{ horizontal: 'center', vertical: 'top' }}
          anchorAlign={{ horizontal: 'center', vertical: 'bottom' }}
          className="max-h-[180px]"
          content={
            <div className="m-1 max-w-[350px]">
              <PopUpContentWrapper
                type="Information"
                contents={[t('Please select at least one item')]}
              />
            </div>
          }
          show={!hasSelectedItems}
        >
          <Button
            color="error"
            size="lg"
            disabled={!hasSelectedItems || isDeletingCartItems}
            loading={isDeletingCartItems}
            onClick={() => {
              void handleDeleteSelected();
            }}
          >
            {t('Delete')}
          </Button>
        </PopUp>
      </div>
    </div>
  );
};

export default ShoppingCartToolbarActions;
